import { Create } from "react-admin";
import { useAuth } from "../../../hooks/useAuth";
import CarrierFields from "./Fields";

export const CarrierCreate = () => {
  const { user, isAgencyAdmin, isFullAdmin } = useAuth();

  return (
    <Create redirect="list">
      <CarrierFields
        user={user}
        isAgencyAdmin={isAgencyAdmin}
        isFullAdmin={isFullAdmin}
      />
    </Create>
  );
};
export default CarrierCreate;
